// extracted by mini-css-extract-plugin
module.exports = {"signoutButton":"SignOut_signoutButton__d8wRt","icon":"SignOut_icon__l070E"};